<template>
    <div class="other-wrap">
        <div class="extract-text-body">
            <el-input
                    style="font-size: 12px"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 6 }"
                    placeholder="请输入需要插入的内容"
                    v-model="textarea">
            </el-input>
            <el-button class="extract-submit-button" type="primary" size="small"
                       @click="insertText"
            >在当前光标处插入内容
            </el-button>
        </div>
        <div class="extract-text-body adjust-margin">
            <el-button class="extract-submit-button" type="primary" size="small"
                       @click="dialogFormVisible7 = true">批注提取
            </el-button>
            <div class="extract-text-field">{{commentText}}</div>
            <div class="error-text">{{this.error2}}</div>
        </div>
        <div class="extract-text-body adjust-margin">
            <el-button class="extract-submit-button" type="primary" size="small"
                        @click="dialogFormVisible8 = true">修订提取
            </el-button>
            <div class="extract-text-field">{{commentRevision}}</div>
            <div class="error-text">{{this.error3}}</div>
        </div>
        <div class="extract-text-body">
            <div class="extract-text-field">{{selectedText}}</div>
            <div class="error-text">{{this.error1}}</div>
            <el-button class="extract-submit-button adjust-button" type="primary" size="small"
                       @click="extractText">获取选中的文字内容
            </el-button>
        </div>
        <div class="extract-text-body">
            <el-button class="extract-submit-button adjust-button" type="primary" size="small" @click="dialogFormVisible4=true">检索</el-button>
            <!-- <el-button class="extract-submit-button adjust-button" type="primary" size="small" @click="dialogFormVisible6 = true">水印设置</el-button> -->
        </div>
        <div class="extract-text-body">
        </div>
        <div class="extract-text-body">
            <el-button class="extract-submit-button adjust-button" type="primary" size="small" @click="dialogFormVisible2 = true">JSON回填</el-button>
        </div>
        <div class="extract-text-body">
            <el-button class="extract-submit-button adjust-button" type="primary" size="small" @click="outJson">转换为JSON</el-button>
             <div class="extract-text-field">{{commentJson}}</div>
            <div class="error-text">{{this.error4}}</div>
        </div>
        <!-- 设置检索关键字内容弹出框 -->
        <el-dialog
                :visible.sync="dialogFormVisible4"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="600px"
        >
            <template slot="title">
                <div class="dialog4-title">需要检索关键字的内容</div>
            </template>
            <el-input 
                    type="input"
                    :rows="9"
                    placeholder="请输入内容"
                    v-model="textarea4"
                    style="height: 219px"
            >
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible4 = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="keySearch"
                           size="small"
                           class="dialog-button"
                           :disabled="!textarea4">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 设置提取批注弹出框 -->
        <el-dialog
                :visible.sync="dialogFormVisible7"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="600px"
        >
            <template slot="title">
                <el-select v-model="value" placeholder="请选择提取批注的范围">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </template>
            <el-input 
                    type="input"
                    :rows="9"
                    placeholder="请输入内容域ID或者用户名ID（如未输入则为全文档提取批注）"
                    v-model="textarea7"
                    style="height: 219px"
            >
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible7 = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="extractComment"
                           size="small"
                           class="dialog-button"
                           :disabled="!value">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 设置提取修订弹出框 -->
        <el-dialog
                :visible.sync="dialogFormVisible8"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="600px"
        >
            <template slot="title">
                <div></div>
            </template>
            <el-input 
                    type="input"
                    :rows="9"
                    placeholder="请输入内容域ID（如未输入则为全文档提取修订）"
                    v-model="textarea8"
                    style="height: 219px"
            >
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible8 = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="extractRevision"
                           size="small"
                           class="dialog-button"
                           >确 定</el-button>
            </div>
        </el-dialog>
        <!-- 设置JSON回填弹出框 -->
        <el-dialog
                :visible.sync="dialogFormVisible2"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="600px"
        >
            <template slot="title">
                <div class="dialog4-title">需要回填JSON的内容</div>
            </template>
            <el-tabs>
                <el-tab-pane label="JSON文本">
                    <div>正确格式实例："{\"body\":[{\"p\":[{\"@style\":\"border:none\"},{\"order\":0},{\"span\":[{\"order\":0},{\"@value\":\"回填数据修改\",\"@style\":\"font-size:0.91em;color:#000000\"}]}]}]}"</div>
                    <el-alert
                            title="此操作会清除原有内容"
                            type="info"
                            show-icon
                            :closable="false"
                            style="margin-bottom: 14px;"
                    >
                    </el-alert>
                    <el-tabs>
                        <el-input 
                                type="input"
                                :rows="9"
                                placeholder="请输入内容"
                                v-model="textarea2"
                                style="height: 219px"
                        >
                        </el-input>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="setReJson"
                           size="small"
                           class="dialog-button"
                           :disabled="!textarea2">确 定</el-button>
            </div>
            <div>

            </div>

        </el-dialog>
    </div>
</template>s

<script>
  
    export default {
        name: "otherApplication",
       
        props: ['docEditor', 'extractedText', 'extractedComment','config','extractedRevision','outjson'],
        data: function() {
            return {
                baseUrl: config.baseUrl,
                error1: '',
                error2: '',
                error3: '',
                error4: '',
                selectedText: '',
                commentText: '',
                commentRevision:'',
                commentJson:'',
                textarea: '',
                textarea2: '',
                textarea3: '',
                textarea4: '',
                textarea5: '',
                textarea7: '',
                textarea8: '',
                // fileExt:'docx',
                waterWidth: 6,
                waterHeight:'',
                rotate:'',
                types:'',
                transparent:'',
                text:'',
                form:{
                    language:'中文',
                    text:'ASAP'
                },
                form1:{
                    mode:'部分编辑模式',
                },
                formLabelWidth: '60px',
                currentType: null,
                dialogFormVisible: false,
                dialogFormVisible2: false,
                dialogFormVisible3: false,
                dialogFormVisible4: false,
                dialogFormVisible5: false,
                dialogFormVisible6: false,
                dialogFormVisible7: false,
                dialogFormVisible8: false,
                dialog: {                   // dialog显示隐藏
                    dialogDrag: true,       // 可拖拽
                    dialogChange: false,    // 可拉伸
                },
                selectlang: 'zh',
                selectUser: {
                    name: '张婷平',
                    id: 'uid-1'
                },
                // selectUserId: 'uid-1',
                // selectUserName: '张婷平',
                selectMode: 'edit',
                options: [{
                    value: '选项1',
                    label: '全文档提取'
                    }, {
                    value: '选项2',
                    label: '可在选定内容域中提取'
                    }],
                value: '',
                textarea1:'',
                ctctrlChildren: [],
                partauthMode: 'level',
                haveorno:'nohave',

                }
        },
        created() {
        },
        methods: {
            extractText: function() {
                var expression = {
                    object: "text",
                    type: "selected",
                }
                this.docEditor.getDocumentContent(expression)
                setTimeout(() => {
                    log("this.extractedText", this.extractedText)
                    if (!this.extractedText['text']) {
                        this.error1 = '请先选中文字'
                        this.selectedText = ''
                    } else {
                        this.error1 = ''
                        this.selectedText = this.extractedText['text']
                    }
                }, 200)
            },
            setArray:function(arr){
                var arrs=[]
                if(arr){
                    arrs = arr.split(",")
                    
                }
                    return arrs
            },
            setIdforComm:function(arr){
                var arrs=[]
                var arr1=[]
                var objects={}
                var object={Id:'1'}
                if(arr){
                    arrs = arr.split(",")
                }
                for(var i=0;i<arrs.length;i++){
                    for (var key in object){
                        objects[key]=Number(arrs[i])
                    }               
                    arr1.push(objects)
                    objects={}
                }
                console.log("arr1",arr1)
                return arr1
            },
            extractComment: function() {
                // 在文字处理中提取当前文档的批注信息
                var expression={}
                console.log("valueeeee"+this.value)
                if (this.value=="选项1"){
                    console.log("选项1",this.setArray(this.textarea7))
                    expression = {
                        object: 'text',
                        type: 'getComment',
                        tree: false,   // 参数说明：批注信息是否按照层级结构显示，参数为boolean类型，默认为false 选填项。true表示批注信息按照层级结构展示，false表示批注信息不按照层级结构展示。
                        user: this.setArray(this.textarea7)
                    }   // 参数说明：根据指定的用户名字获取批注，参数为array，数组元素为用户的名字 选填项
                    this.docEditor.getDocumentContent(expression)
                    this.dialogFormVisible7 = false
                    setTimeout(() => {
                        log("this.extractedComment",this.extractedComment['text'])
                        if(!this.textarea7){
                            if (this.extractedComment['text']['allUser'].length === 0) {
                                this.error2 = '此文档还没有批注内容'
                                this.commentText = ''
                            }else{
                                this.error2 = ''
                                this.commentText = this.extractedComment['text'] 
                            }
                        }else{
                            if (this.extractedComment['text'][this.textarea7].length === 0) {
                                this.error2 = '此文档还没有批注内容'
                                this.commentText = ''
                            }else{
                                this.error2 = ''
                                this.commentText = this.extractedComment['text'] 
                            }
                        }
                     }, 200)
                }else if(this.value=='选项2'){
                    console.log("进来了吗选项2",this.setIdforComm(this.textarea7))
                    expression = {
                        object: "comment",	//必填项，表示提取的为批注
                        range:this.setIdforComm(this.textarea7) 	//必填项，表示提取批注的范围。如果是空数组，表示提取全文的批注
                    }
                    this.docEditor.getDocumentContent(expression)
                    this.dialogFormVisible7 = false
                    setTimeout(() => {
                        log("this.extractedComment", this.extractedComment['comment'])
                        
                            if (this.extractedComment['comment'].length === 0) {
                            this.error2 = '此文档还没有批注内容'
                            this.commentText = ''
                            }else{
                                this.error2 = ''
                                this.commentText = this.extractedComment['comment']
                            }
                         
                    }, 200)   
                }
            },
            extractRevision:function(){
                var expression = {
                    object:"revision",        //必填项，表示提取的为修订
                    type:"addAndDelete",        //必填项 提取的修订类型为新增文字或者删除文字
                    range: this.setIdforComm(this.textarea8),	//必填项，表示提取修订的范围。如果是空数组，表示提取全文的修订
                }
                this.docEditor.getDocumentContent(expression)
                console.log('修订提取')
                setTimeout(() => {
                    log("this.extractedRevision", this.extractedRevision)
                    if(!this.textarea8){
                        if (this.extractedRevision['revision'].length === 0) {
                        this.error3 = '此文档还没有修订内容'
                        this.commentRevision = ''
                        }else {
                        this.error3 = ''
                        this.commentRevision = this.extractedRevision['revision']
                    }
                    } else {
                        this.error3 = ''
                        this.commentRevision = this.extractedRevision['revision']
                    }
                    
                }, 200)
                this.dialogFormVisible8=false
            },
            keySearch:function(){
                this.docEditor.showSearchResults(this.textarea4);
                this.dialogFormVisible4=false
            },
            setReJson:function(){
                var expression = {
                    object: 'content',
                    type:'jsonReplace',
                }
                expression.json=this.textarea2
                console.log(this.textarea2,'exp')
                this.docEditor.setDocumentContent(expression);
                this.dialogFormVisible2 = false;
            },
            outJson:function() {
                var expression = {
                    object:'content',
                    type:'json',
                }
                this.docEditor.getDocumentContent(expression);
                setTimeout(() => {
                    log("this.outjson", this.outjson['text'])
                    if (this.outjson['text'].length === 0) {
                        this.error4 = '此文档没有可转换为JSON的内容'
                        this.commentJson = ''
                    } else {
                        this.error3 = ''
                        this.commentJson = this.outjson['text']
                    }
                }, 200)
            },
            insertText: function() {
                var expression = {
                    object: 'text',
                    type: 'insert',
                    text: this.textarea,
                }
                this.docEditor.setDocumentContent(expression)
            },
            
        }
    }
</script>

<style scoped>
    .other-wrap {
        padding: 0 15px;
    }
    .extract-text-body {

    }
    .extract-text-field {
        /*width: 93%;*/
        box-sizing: border-box;
        height: 100px;
        /*max-height: 500px;*/
        background-color: #ffffff;
        border: 1px solid #E0E0E0;
        overflow-y: auto;
        border-radius: 4px;
        padding: 10px;
        line-height: 20px;
    }
    .extract-submit-button {
        margin: 5px 0;
    }
    .adjust-button {
        margin-top: 0;
    }
    .adjust-margin {
        margin-bottom: 30px;
    }
    .error-text {
        height: 22px;
        width: 147px;
        font-size: 12px;
        line-height: 20px;
        text-align: left;
        color: #F45858;
    }
</style>


// WEBPACK FOOTER //
// src/components/otherApplication.vue